<template>
	<b-modal ref="load-modal" title="Load Scenario" v-model="showLoad" :modal-class="'full-modal no-header no-footer'">
		<div class="container pt-4 pb-0">
			<h2 class="text-uppercase">Load Scenario</h2>
		</div>
		<hr class='mb-0' />
		<div class='load-wrapper pt-1'>
			<div class="container pt-1">

				<div class="row pb-2 pt-2 align-items-center border-bottom" v-for="(save, index) in saves" v-bind:key="index">
					<div class="col-2">
						<a v-if="save.state != 'edit'" href="#" @click.prevent="save.state = 'edit'" class="text-muted">Rename</a>
						<button v-if="save.state == 'edit'" @click.prevent="renameScenario(index)" class="btn border-dark form-control"> <i class="app-icon folder"></i> Save</button>
					</div>
					<div class="col-8 ">
						<input v-if="save.state == 'edit'" v-model="save.name" class="form-control" />
						<span v-if="save.state != 'edit'">
							{{save.name}}
						</span>
					</div>
					<div class="col-2">
						<a href="#" class="mr-2" @click.prevent="deleteScenario(index)"><i class="app-icon trash bordered round"></i></a>
						<a href="#" @click="loadScenario(index)"><i class="app-icon play round bg-success"></i></a>
					</div>
				</div>

				<div class="alert alert-info" v-if="Object.keys(saves).length == 0">No saved scenarios found.</div>
			</div>
		</div>


		<div class="footer-btns">
			<div class="container">
				<button class="app-btn btn btn-dark" @click.prevent="view=null">
					<i class="app-icon back mr-2"></i> Back
				</button>
			</div>
		</div>
	</b-modal>
</template>

<style scoped lang="scss" rel="stylesheet/scss">
	.footer-btns {
		position: absolute;
		bottom: 30px;
		text-align: right;
		width: 100%;
	}
	.load-wrapper {
		max-height: calc(100vh - 200px);
		overflow-y: auto;
	}
</style>

<script>

	import * as workerTimers from 'worker-timers';
	import { keys, get, set, del } from 'idb-keyval';

	export default {
		name: 'Load',
		data() {
			return {
				showLoad: false,
				saves: {}
			}
		},
    	computed: {
			view: {
				get() { return this.$store.state.view },
				set(value) { this.$store.commit('setState', ['view', value])}
			},
			logged: {
				get() { return this.$store.state.logged },
				set(value) { this.$store.commit('setState', ['logged', value])}
			},
			load: {
				get() { return this.$store.state.load },
				set(value) { this.$store.commit('setState', ['load', value]) }
			},
		},
		methods: {
			async renameScenario(index) {
				let save = this.saves[index];
				let data = await get(index);//localStorage.getItem(index);
				del(index);
				set('save-'+save.name, data);
				save.state = null;
				save.renamed = true;

			},
			async deleteScenario(index) {
				del(index);
				this.saves = await this.getStorage();
			},
			async loadScenario(index) {
				await this.$store.dispatch('load', {storage_item: index});
				this.view = 'game';
				this.logged = true;
			},
			async getStorage() {
				//let storage = localStorage;
				let saves = {};
				let storage = await keys();

				for (let i in storage) {
					let key = storage[i];
					let name = key.replace('save-', '', key);
					if (key.match('save-')) saves[key] = {'name': name, 'state': null, 'renamed': false};
				}
				return saves;
			}
		},
		watch: {
			view: {
				async handler() {
					this.showLoad =  (this.$store.state.view == 'load');
					this.saves = await this.getStorage();
				},
				immediate: true
			}
		},
		async mounted() {
			this.saves = await this.getStorage();
		}

	}
</script>
